module.exports = __webpack_public_path__ + "img/android-en.835b87d7.png";